var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-bar"}},[_c('div',{staticClass:"loader-bar",style:({'color': _vm.object,'font-size': _vm.size+'px',})},[_vm._v("Loading..")])])}
var staticRenderFns = []

export { render, staticRenderFns }